import WaybillsTableColumnMoney from './index.vue'
export default WaybillsTableColumnMoney